/* global DetectUserAgent */
import { Workbox } from "workbox-window";

export function registerServiceWorker(onPageRefresh) {
  if (!DetectUserAgent.isPrerender() && "serviceWorker" in navigator) {
    const wb = new Workbox("/service-worker.js");

    const showSkipWaitingPrompt = () => {
      onPageRefresh();
      window.onPageRefresh = () => {
        wb.messageSkipWaiting();
        window.location.reload();
      };
    };

    wb.addEventListener("waiting", showSkipWaitingPrompt);

    wb.register();
  }
}
